import { useCallback, useContext } from 'react';

import { Context, IStore } from 'components/hoc/Store';

// Custom hook pro zmenu prvni urovne v Contextu
const useProfily = () => {
    const { setStoreState = () => {} } = useContext(Context);
    const setterFunc = <T extends keyof IStore>(key: T, values: IStore[T]) => {
        setStoreState(pv => {
            return {
                ...pv,
                [key]: values
            };
        });
    };

    // Pouziti useCallback aby jsme zabranili zbytecnemu reRenderovani pri zmene hodnot ve store
    const setLevel = useCallback(setterFunc, [setStoreState]);
    return {
        setLevel
    };
};

export default useProfily;
